import { Player, User } from '@tcc-mono/classifact/shared/data-access/models';
export class UserDetails extends User {
  tenantNames?: string[];
  teamNames?: string[];
  player?: Player;
}
